<main class="monitoring-map" dir="rtl">
  <header class="monitoring-header">
    <div class="heading">
      <h1>نقشه پایش تصویری</h1>
      <p>موقعیت و تصاویر خودروها</p>
    </div>
    <div class="toolbar" aria-label="فیلترهای نقشه">
      <input class="field search" type="search" placeholder="نام خودرو، پلاک یا شناسه"
        aria-label="جست‌وجوی خودرو" [(ngModel)]="search" (ngModelChange)="updateMarkers()">
      <select class="field" aria-label="وضعیت خودرو" [(ngModel)]="status" (ngModelChange)="updateMarkers(); resetView()">
        <option value="all">همه وضعیت‌ها</option>
        <option *ngFor="let item of statuses; let i = index" [value]="i">{{ item.label }}</option>
      </select>
      <select class="field" aria-label="نوع تصویر" [(ngModel)]="category" (ngModelChange)="updateMarkers()">
        <option value="cabin">تصاویر کابین</option>
        <option value="outside">تصاویر بیرون</option>
      </select>
      <label class="check"><input type="checkbox" [(ngModel)]="onlyImages" (ngModelChange)="updateMarkers(); resetView()"> فقط دارای تصویر</label>
      <button class="button" type="button" [disabled]="mapUnavailable" (click)="resetView()">
        <i class="fa fa-expand" aria-hidden="true"></i> نمایش همه
      </button>
      <button class="button button-primary" type="button" [disabled]="loading" (click)="loadImages()">
        <i class="fa fa-refresh" aria-hidden="true"></i> به‌روزرسانی
      </button>
    </div>
    <div class="summary" aria-label="آمار خودروها">
      <span class="metric">خودرو <b>{{ hasLoaded ? (vehicles.length | faNum) : '—' }}</b></span>
      <span class="metric">نمایش <b>{{ hasLoaded ? (filteredVehicles.length | faNum) : '—' }}</b></span>
      <span class="metric">تصویر <b>{{ hasLoaded ? (visibleImageCount | faNum) : '—' }}</b></span>
    </div>
  </header>

  <section class="workspace" aria-label="نقشه پایش تصویری">
    <div class="map-area">
      <div class="request-state" *ngIf="loading && !hasLoaded" role="status">
        <span class="spinner" aria-hidden="true"></span><span>در حال دریافت تصاویر…</span>
      </div>
      <div class="request-state request-error" *ngIf="!loading && loadError && !hasLoaded" role="alert">
        <span>{{ loadError }}</span><button class="button" type="button" (click)="loadImages()">تلاش دوباره</button>
      </div>
      <app-monitoring-map [vehicles]="filteredVehicles" [images]="images" [category]="category"
        [showThumbnails]="showThumbnails" [clustersEnabled]="clustersEnabled" [hasLoaded]="hasLoaded"
        (vehicleSelected)="selectedVehicle = $event">
      </app-monitoring-map>
      <div class="map-actions">
        <button class="button" type="button" [attr.aria-pressed]="showThumbnails" (click)="showThumbnails = !showThumbnails; updateMarkers()">تصاویر: {{ showThumbnails ? "روشن" : "خاموش" }}</button>
        <button class="button" type="button" [attr.aria-pressed]="clustersEnabled" (click)="clustersEnabled = !clustersEnabled; updateMarkers()">خوشه‌بندی: {{ clustersEnabled ? "روشن" : "خاموش" }}</button>
      </div>
      <div class="map-notice" *ngIf="!mapUnavailable && hasLoaded">{{ filteredVehicles.length ? "با انتخاب هر خودرو، تصویر آن را ببینید." : "خودرویی با موقعیت معتبر برای نمایش پیدا نشد." }}</div>
      <div class="map-notice" *ngIf="mapUnavailable" role="status">آدرس سرویس نقشه تنظیم نشده است.</div>
      <div class="legend" aria-label="راهنمای وضعیت خودروها">
        <span><i class="dot unknown"></i>نامشخص</span><span><i class="dot connected"></i>متصل به سرور</span>
        <span><i class="dot disconnected"></i>قطع ارتباط</span><span><i class="dot moving"></i>حرکت</span>
        <span><i class="dot stopped"></i>توقف</span><span><i class="dot off"></i>سوئیچ بسته</span>
        <span><i class="dot on"></i>سوئیچ باز</span><span><i class="dot status-alert"></i>اخطار</span>
      </div>
    </div>
    <footer class="statusbar"><span>نمایش خودروها روی نقشه</span><span>{{ filteredVehicles.length | faNum }} خودرو</span></footer>
  </section>
</main>

<app-map-image-dialog *ngIf="selectedVehicle as vehicle" [vehicle]="vehicle" [images]="images"
  [category]="category" [statusLabel]="(statuses[vehicle.tiDeviceStatus || 0] || statuses[0]).label"
  (close)="selectedVehicle = null" (zoomVehicle)="zoomToSelectedVehicle()">
</app-map-image-dialog>
